import { v4 as uuidv4 } from 'uuid';
import { callServiceAPI } from './ApiUtils';
var manufOmsWebServicesPrefix = "https://api.manuf.appmachine.in";

export function submitOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/submitorder", "PUT", payload, successCallBack, failuerCallback);
}export function approveOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/approveorder", "PUT", payload, successCallBack, failuerCallback);
}export function rejectOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/rejectorder", "PUT", payload, successCallBack, failuerCallback);
}export function orderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/order", "POST", payload, successCallBack, failuerCallback);
}export function updateOrderPartyAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/updateorderparty", "PUT", payload, successCallBack, failuerCallback);
}export function updateOrderRemarksAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/orderremarks", "PUT", payload, successCallBack, failuerCallback);
}export function updateTaskStatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/updatetaskstatus", "PUT", payload, successCallBack, failuerCallback);
}export function initWorkflowAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/workflow", "POST", payload, successCallBack, failuerCallback);
}export function GetInventoryAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/getinventory", "POST", payload, successCallBack, failuerCallback);
}export function manageInventoryAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/manageinventory", "PUT", payload, successCallBack, failuerCallback);
}export function addInventoryAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/addinventory", "POST", payload, successCallBack, failuerCallback);
}export function genStockOutReqAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/genstockoutreq", "POST", payload, successCallBack, failuerCallback);
}export function getOrderFormAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/getorderform", "POST", payload, successCallBack, failuerCallback);
}export function updateproductorderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/updateproductorder", "PUT", payload, successCallBack, failuerCallback);
}export function getStockoutReqPdfAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/getstockoutreqpdf", "POST", payload, successCallBack, failuerCallback);
}export function cancelProductOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/cancelproductorder", "POST", payload, successCallBack, failuerCallback);
}export function addStockOrderProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/addstockorderproduct", "POST", payload, successCallBack, failuerCallback);
}export function receiveStockOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/receivestockorder", "PUT", payload, successCallBack, failuerCallback);
}export function placeStockOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/placestockorder", "PUT", payload, successCallBack, failuerCallback);
}export function getStockOrderFormAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/getstockorderform", "POST", payload, successCallBack, failuerCallback);
}export function updateStockOrderPartyAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/updatestockorderparty", "PUT", payload, successCallBack, failuerCallback);
}export function receiveStockOrderProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/receivestockorderproduct", "PUT", payload, successCallBack, failuerCallback);
}export function addAssetToProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/addassetoproduct", "POST", payload, successCallBack, failuerCallback);
}export function getAssetsAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/getAssets", "POST", payload, successCallBack, failuerCallback);
}export function sendEmailCampaignAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/sendemailcampaign", "POST", payload, successCallBack, failuerCallback);
}export function testEmailCampaignAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/testemailcampaign", "POST", payload, successCallBack, failuerCallback);
}export function updateStitchingTaskStatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/updatestitchingtaskstatus", "PUT", payload, successCallBack, failuerCallback);
}export function sendWhatisupMsgAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/sendwhatisupmsg", "POST", payload, successCallBack, failuerCallback);
}export function queryAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/query", "POST", payload, successCallBack, failuerCallback);
}export function RunReportAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/runreport", "POST", payload, successCallBack, failuerCallback);
}export function GetReportDataAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(manufOmsWebServicesPrefix+"/getreportdata", "POST", payload, successCallBack, failuerCallback);
}